module.exports = {
  "country": "IT",
  "artist": "Marco Mengoni",
  "song": "Due Vite",
  "year": "2023",
  "place": "4",
  "spotify": "1kLkueHl8SdYc31QQ5PbS0"
};